import { useState } from 'react';
import { FEEXPAY_WEBHOOK_EVENTS } from '@/lib/feexpayWebhook';

export default function EventsCard() {
  const required = FEEXPAY_WEBHOOK_EVENTS.filter((e) => e.required).map((e) => e.id);
  const [selected, setSelected] = useState<string[]>(required);

  const toggle = (id: string) => {
    setSelected((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  };

  const allSelected = selected.length === FEEXPAY_WEBHOOK_EVENTS.length;
  const toggleAll = () => setSelected(allSelected ? [] : FEEXPAY_WEBHOOK_EVENTS.map((e) => e.id));

  return (
    <div className="rounded-lg border border-background-200/70 bg-background-50 p-5">
      <div className="flex items-start gap-3 mb-4">
        <div className="w-10 h-10 rounded-lg bg-accent-100 text-accent-700 flex items-center justify-center flex-shrink-0">
          <i className="ri-notification-3-line text-lg"></i>
        </div>
        <div className="min-w-0 flex-1">
          <h3 className="text-sm font-bold text-foreground-950">Événements à sélectionner</h3>
          <p className="text-[11px] text-foreground-500 mt-0.5">
            Dans FeexPay, ouvrez « Sélectionner les événements » et cochez ces cases.
          </p>
        </div>
      </div>

      <button
        type="button"
        onClick={toggleAll}
        className="mb-3 h-8 px-3 rounded-full border border-background-200/70 text-[11px] font-medium text-foreground-600 whitespace-nowrap hover:bg-background-100 transition-colors cursor-pointer"
      >
        {allSelected ? 'Tout décocher' : 'Tout cocher'}
      </button>

      <ul className="space-y-1.5">
        {FEEXPAY_WEBHOOK_EVENTS.map((event) => {
          const checked = selected.includes(event.id);
          return (
            <li key={event.id}>
              <button
                type="button"
                onClick={() => toggle(event.id)}
                className={`w-full flex items-start gap-2.5 rounded-md border px-3 py-2 text-left transition-colors cursor-pointer ${
                  checked
                    ? 'border-accent-200 bg-accent-50/60'
                    : 'border-background-200/70 bg-background-50 hover:bg-background-100'
                }`}
              >
                <span
                  className={`mt-0.5 w-4 h-4 rounded-[4px] border flex items-center justify-center flex-shrink-0 ${
                    checked ? 'bg-accent-500 border-accent-500 text-background-50' : 'border-background-300 bg-background-50'
                  }`}
                >
                  {checked && <i className="ri-check-line text-[10px]"></i>}
                </span>
                <span className="min-w-0">
                  <span className="flex items-center gap-2 flex-wrap">
                    <span className="text-[11px] font-semibold text-foreground-900">{event.label}</span>
                    <code className="text-[10px] font-mono text-foreground-400">{event.id}</code>
                  </span>
                  <span className="block text-[10px] text-foreground-500 mt-0.5 leading-relaxed">{event.description}</span>
                </span>
              </button>
            </li>
          );
        })}
      </ul>

      <p className="text-[10px] text-foreground-400 mt-3 flex items-start gap-1.5">
        <i className="ri-information-line mt-0.5"></i>
        Aide-mémoire : le webhook sait traiter tous les événements, aucun réglage supplémentaire n’est nécessaire ici.
      </p>
    </div>
  );
}